import ErrorText from '../ErrorText';

export default function ReactHookFormError({ errors, className }) {
  const errorEntries = Object.entries(errors);

  if (errorEntries == null || errorEntries?.length < 1) {
    return null;
  }

  return (
    <ErrorText
      message={errorEntries[0][1]?.message}
      className={`${className ? className : ''}`}
    />
  );
}
